import { ClickOutsideController } from 'stimulus-use'

export default class extends ClickOutsideController {
    static targets = ['button'];
    static values = {
        labelOpened: { type: String, default: 'Menü öffnen'},
        labelClosed: { type: String, default: 'Menü schließen'},
    }

    toggle() {
        document.body.classList.toggle('show-ws25-menu');

        if (document.body.classList.contains('show-ws25-menu')) {
            this.buttonTarget?.setAttribute('aria-expanded', 'true');
            this.buttonTarget?.setAttribute('aria-label', this.labelClosedValue);
        } else {
            this.buttonTarget?.setAttribute('aria-expanded', 'false');
            this.buttonTarget?.setAttribute('aria-label', this.labelOpenedValue);
        }
    }

    close() {
        document.body.classList.remove('show-ws25-menu');
        this.buttonTarget?.setAttribute('aria-expanded', 'false');
        this.buttonTarget?.setAttribute('aria-label', this.labelOpenedValue);
    }

    buttonTargetDisconnected(button) {
        button.setAttribute('aria-expanded', 'false');
        button.setAttribute('aria-label', this.labelOpenedValue);
    }

    disconnect() {
        document.body.classList.remove('show-ws25-menu');
    }

    clickOutside() {
        this.close();
    }
}
